import { FindQuery } from '../../../CORE/src/common/$models'

export { SERVICE_LEVEL_NOTICE_HIDDEN_PAGES_DIRECTUS_HINT } from '../YhcServiceLevelList/serviceLevelNoticePageUtils'

/** @deprecated SERVICE_LEVEL_NOTICE_HIDDEN_PAGES_DIRECTUS_HINT を使用してください */
export { SERVICE_LEVEL_NOTICE_HIDDEN_PAGES_DIRECTUS_HINT as SERVICE_LEVEL_NOTICE_HIDE_ON_CORP_DIRECTUS_HINT } from '../YhcServiceLevelList/serviceLevelNoticePageUtils'

/**
 * ログインしていない状態で レコードを fetch するための関数
 * @param modelName
 * @param query
 */
export const findRecordsByModelName = async (
  modelName: string,
  query: Partial<FindQuery>,
): Promise<any[]> => {
  // @ts-ignore
  return (await $core.$d.items(modelName).readByQuery(query))?.data || []
}

export const findById = async (
  modelName: string,
  id: number | string,
  idPropName = 'id',
): Promise<any> => {
  return (
    (
      await $core.$d.items(modelName).readByQuery({
        filter: {
          [idPropName]: {
            _eq: id,
          },
        },
      })
    )?.data?.[0] || null
  )
}
